import { useQuery } from '@tanstack/react-query';
import { requestSavedPaymentMethods, savedPaymentMethodsKey, selectBankAccounts } from '../paymentApi';

/** The member's saved bank accounts for the Payment Accounts page. */
export function useSavedBankAccounts() {
  return useQuery({
    queryKey: savedPaymentMethodsKey,
    queryFn: requestSavedPaymentMethods,
    select: selectBankAccounts,
  });
}
